import { Button, FormAutoGenerated, Wrapper } from '@visualfabriq/vf-ui-kit';
import {
  FieldItem,
  FormLayoutRow,
} from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';

import * as DataProcessingStep from 'src/dto/PipelineStep/DataProcessingStep';

import { requiredField } from 'src/components/UIKitTweaks';
import { DataProcessingArgs } from 'src/api-new/bifrost';

type Props = {
  arg: DataProcessingArgs;
  action: 'create' | 'update';
  onChange: (value: DataProcessingArgs) => void;
  onValidChange: (isValid: boolean) => void;
  onCreate: () => void;
  onDelete: (id: string) => void;
  onCancel: () => void;
};

export function Arg(props: Props) {
  const { arg, action, onChange, onCreate, onCancel, onDelete, onValidChange } = props;
  const { key, description } = arg;

  const handleCreate = () => {
    onCreate();
  };

  const isValid = Boolean(key && description);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleFormChange = (event: any) => {
    onChange({ ...arg, ...event });
  };

  return (
    <>
      <FormAutoGenerated
        fields={FORM_FIELDS}
        layout={FIELDS_LAYOUT}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        initData={arg as any}
        onDataChange={handleFormChange}
        onFormValidChange={onValidChange}
      />
      <Wrapper gap="200">
        {action === 'create' && (
          <Button disabled={!isValid} onClick={handleCreate}>
            Create
          </Button>
        )}
        <Button kind="secondary" onClick={action === 'create' ? onCancel : () => onDelete(arg.id)}>
          {action === 'create' ? 'Cancel' : 'Delete'}
        </Button>
      </Wrapper>
    </>
  );
}

const FORM_FIELDS: FieldItem[] = [
  {
    field_id: 'key',
    field_desc: 'Key',
    ...requiredField,
    data_type: 'text',
  },
  {
    field_id: 'type',
    field_desc: 'Type',
    data_type: 'select',
    ...requiredField,
    value_list: (['text', 'boolean', 'number', 'dict', 'list', 'date'] as DataProcessingStep.ArgsType[]).map(
      (type) => ({
        value_id: type,
        value_name: type,
        id: type,
        name: type,
      }),
    ),
  },
  {
    field_id: 'default_value',
    field_desc: 'Default Value',
    data_type: 'text',
  },
  {
    field_id: 'description',
    field_desc: 'Description',
    ...requiredField,
    data_type: 'text',
  },
];
const FIELDS_LAYOUT: FormLayoutRow[] = FORM_FIELDS.map((field) => [{ field: field.field_id, cols: [4, 6, 12] }]);
